import { CPFValidator } from '@/shared/services/cpf-validator/cpf-validator'
import { CPFValidatorAdapter } from '@/shared/services/cpf-validator/cpf-validator-adapter'

export const cpfValidator = new CPFValidator(new CPFValidatorAdapter())
